module.exports = __webpack_public_path__ + "static/feature1-468dda1b0e06dfde7504815e0249a0c9.png";